import i18n from '../i18n';
var TEAMFLECT_TENANT_ID = '888a859c-c680-4344-ab07-24bd768bf73a';
// TODO: Move them to corresponding files when gathering every custom tenant into files
var TENANTS_USING_RESULTS_IN_NAV = [
    '76d4630d-ffb0-41b8-9be1-6d5999a8cf42'
] // AuditdataAD
;
var TENANTS_USING_PROJECTS_IN_NAV = [
    '7a553754-2e8d-4a1f-b57a-56d5f9d1cb13'
] // Trolley General Trading
;
var TENANTS_HIDING_SIGNATURE_IP = [
    '24d9f80e-4608-4ecd-9a1f-1c5de98cfee6'
] // Comline
;
var TENANTS_USING_OVERARCHING_GOAL_LABEL = [
    '9c6c3caa-8f3d-4f3c-98f7-e4feea479b7d'
] // The Watson Constitute
;
var TENANTS_HIDING_PARENT_AND_SUBGOAL_FIELDS = [
    '839bd755-86cb-4026-b14e-56aae44a0acf' // Neko Health AB
];
var TENANTS_USING_GROWTH_PLAN = [
    'da8d1b42-b203-42c8-a03c-4f84c1f7e2c0'
] // Areim
;
var TENANTS_HIDING_DELETE_ACCOUNT = [
    'ff0b5dfd-2901-4555-a244-19da12ce34ec'
] // Gas South
;
var TENANT_PLACEHOLDER_OVERRIDES = {
    // Centric
    '7e1792ae-4f1a-4ff7-b80b-57b69beb7168': [
        'Make sure to define the performance outcomes for this objective so that it is clear what would qualify as:',
        '',
        '1 – Below expectations',
        '2 – Meets expectations',
        '3 – Exceeds expectations',
        '',
        'Finally, please agree on the objective weight with your manager and include it in the goal title using square brackets.',
        'Example: Engagement score ≥ 7.5 [20%]'
    ].join('\n')
};
var TENANTS_USING_CUSTOM_GOAL_OUTCOMES = [
    '7e1792ae-4f1a-4ff7-b80b-57b69beb7168'
] // Centric
;
// Display-only
var CUSTOM_GOAL_OUTCOME_LABELS = [
    '',
    'On Norm',
    'Above',
    'Below',
    'Dropped'
];
var USER_LICENSE_MODEL = {
    QUEUE: 0,
    MANAGE: 1
};
var SUBSCRIPTION_STATUS = {
    FREE: 1,
    ACTIVE: 3,
    SUSPENDED: 4,
    CANCELED: 5
};
var SUBSCRIPTION_LICENSE_TYPE = {
    ESSENTIAL: 'Essential',
    PROFESSIONAL: 'Professional'
};
var DEFAULT_NINEBOX = {
    xLineText: i18n.t('NineBoxClassification_performance', 'PERFORMANCE'),
    yLineText: i18n.t('NineBoxClassification_potential', 'POTENTIAL'),
    xLevels: {
        low: i18n.t('NineBoxClassification_potentialLow', 'Low'),
        mid: i18n.t('NineBoxClassification_potentialModerate', 'Moderate'),
        high: i18n.t('NineBoxClassification_potentialHigh', 'High')
    },
    yLevels: {
        low: i18n.t('NineBoxClassification_potentialLow', 'Low'),
        mid: i18n.t('NineBoxClassification_potentialModerate', 'Moderate'),
        high: i18n.t('NineBoxClassification_potentialHigh', 'High')
    },
    boxes: [
        {
            x: 1,
            y: 3,
            text: i18n.t('NineBoxClassification_potentialGems', 'Potential Gems'),
            color: '#7C7EB2'
        },
        {
            x: 2,
            y: 3,
            text: i18n.t('NineBoxClassification_highPotentials', 'High Potentials'),
            color: '#6062A1'
        },
        {
            x: 3,
            y: 3,
            text: i18n.t('NineBoxClassification_stars', 'Stars'),
            color: '#444691'
        },
        {
            x: 1,
            y: 2,
            text: i18n.t('NineBoxClassification_inconsistentPerformers', 'Inconsistent Performers'),
            color: '#9899C3'
        },
        {
            x: 2,
            y: 2,
            text: i18n.t('NineBoxClassification_corePlayers', 'Core Players'),
            color: '#7C7EB2'
        },
        {
            x: 3,
            y: 2,
            text: i18n.t('NineBoxClassification_highPerformers', 'High Performers'),
            color: '#6062A1'
        },
        {
            x: 1,
            y: 1,
            text: i18n.t('NineBoxClassification_badHires', 'Bad Hires'),
            color: '#B4B5D3'
        },
        {
            x: 2,
            y: 1,
            text: i18n.t('NineBoxClassification_backups', 'Backups'),
            color: '#9899C3'
        },
        {
            x: 3,
            y: 1,
            text: i18n.t('NineBoxClassification_workhorses', 'Trusted Professionals'),
            color: '#7C7EB2'
        }
    ]
};
var MONTHLY_RECOGNITION_POINT_LIMIT = 100;
var FREE_TENANT_MAX_LICENSE_COUNT = 10;
var MY_ORGANIZATION_SETTING_KEYS = [
    'enableNewsFeedInMyOrganizationPage',
    'enableCompanyResourcesInMyOrganizationPage',
    'enableOrganizationSearchInMyOrganizationPage',
    'enableNewHiresWidgetInMyOrganizationPage',
    'enableInternalJobBoardWidgetInMyOrganizationPage',
    'enableOrganizationChartWidgetInMyOrganizationPage',
    'enableBirthdayOrAnniversaryWidgetInMyOrganizationPage',
    'enableVoiceOfTheEmployeeWidgetInMyOrganizationPage'
];
export { TEAMFLECT_TENANT_ID, TENANTS_USING_RESULTS_IN_NAV, TENANTS_USING_PROJECTS_IN_NAV, TENANTS_HIDING_SIGNATURE_IP, TENANTS_USING_OVERARCHING_GOAL_LABEL, TENANTS_HIDING_PARENT_AND_SUBGOAL_FIELDS, TENANTS_USING_GROWTH_PLAN, TENANTS_HIDING_DELETE_ACCOUNT, TENANT_PLACEHOLDER_OVERRIDES, TENANTS_USING_CUSTOM_GOAL_OUTCOMES, CUSTOM_GOAL_OUTCOME_LABELS, MY_ORGANIZATION_SETTING_KEYS, SUBSCRIPTION_LICENSE_TYPE, USER_LICENSE_MODEL, DEFAULT_NINEBOX, MONTHLY_RECOGNITION_POINT_LIMIT, SUBSCRIPTION_STATUS, FREE_TENANT_MAX_LICENSE_COUNT };
